import * as signalR from '@microsoft/signalr';
import Config from './Config';
/**
 * 通讯客户端
 */
export default class SignalRClient {
    private static instance: SignalRClient;
    private connection: signalR.HubConnection;
    private startPromise: Promise<void> | null = null;

    public static get Instance() : SignalRClient {
        if (this.instance == null) {
            this.instance = new SignalRClient();
        }
        return this.instance;
    }
    
    constructor() {
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl(Config.hubUrl)
            .withAutomaticReconnect() //自动重连
            .build();
        this.connection.onreconnected(() => {
            console.log('重连成功!');
            // 重连成功后重置 startPromise，确保后续调用不会用旧的 rejected promise
            this.startPromise = Promise.resolve();
        });
        this.connection.onreconnecting(() => {
            console.log('重连中!');
        });
        this.connection.onclose(async () => {
            console.log("连接断开!")
            // 断连后重置，下次 invoke 会重新尝试连接
            this.startPromise = null;
        });
    }

    /**
     * 添加监听
     */
    public AddEventListener(key: string, onBackFun: (...args: any[]) => void) {
        this.connection.on(key, onBackFun);
    }

    /**
     * 删除监听
     * @param key 
     */
    public RemoveEventListener(key: string) {
        this.connection.off(key);
    }

    /**
     * 启动服务，最多等待 10 秒
     */
    public async StartAsync() {
        if (this.startPromise) return this.startPromise;
        this.startPromise = Promise.race([
            this.connection.start(),
            new Promise<void>((_, reject) => setTimeout(() => reject(new Error('SignalR 连接超时')), 10000)),
        ]);
        return this.startPromise;
    }

    /**
     * 确保连接已就绪（自动启动）
     */
    private async ensureConnected() {
        if (!this.startPromise) {
            await this.StartAsync();
        } else {
            await this.startPromise;
        }
    }

    /**
     * 发送数据并返回
     * @param args 
     * @returns 
     */
    public async InvokeAsync<T>(action: string, ...args: any[]) {
        await this.ensureConnected();
        return await this.connection.invoke(action, ...args) as T;
    }

    /**
     * 发送数据不返回
     * @param action 
     * @param args 
     */
    public async SendAsync(action: string, ...args: any[]) {
        await this.ensureConnected();
        await this.connection.send(action, ...args)
    }
}